import { useSalonManagerContext } from '@admin/components/templates/SalonManager/context'
import Button from '@blocks/Button'
import Grid from '@blocks/Grid'
import React from 'react'

export default function VotingActions() {
    const { salon } = useSalonManagerContext()

    const finish = () => salon.actions.type.update("finished")

    return (
        <Grid gap="15px">
            <Grid gap="0px">
                <small>Actions</small>
                <hr />
            </Grid>
            <Grid columns="4">
                <Grid gap="10px">
                    <h4>Switch To Results</h4>
                    <small>Restricts juries from voting. Customers will be able to see the results.</small>
                    <Button onClick={finish} type="tertiary">Switch</Button>
                </Grid>
            </Grid>
        </Grid>
    )
}